import { queryBooksAPI } from '../Api/index.ts';

interface Book {
    title: string;
    authors: string;
    isbn: string;
    thumbnail: string | null;
    edition: string;
}

interface GoogleBooksResponse {
    items: Array<{
        volumeInfo: {
            title: string;
            authors?: string[];
            industryIdentifiers?: Array<{ identifier: string }>;
            imageLinks?: { thumbnail: string };
            edition?: string;
        };
    }>;
}

export const handleSearch = async (
    value: string, 
    setSearchResults: (results: Book[]) => void, 
    setSearching: (searching: boolean) => void
): Promise<void> => {
    if (!value || value.length < 2) {
        setSearchResults([]);
        return;
    }

    setSearching(true);
    try {
        const response = await queryBooksAPI(value);
        const data: GoogleBooksResponse = await response.json();

        if (data.items) {
            const books: Book[] = data.items.map(item => ({
                title: item.volumeInfo.title,
                authors: item.volumeInfo.authors ? item.volumeInfo.authors.join(', ') : 'Unknown Author',
                isbn: item.volumeInfo.industryIdentifiers ? 
                    item.volumeInfo.industryIdentifiers[0].identifier : '',
                thumbnail: item.volumeInfo.imageLinks ? item.volumeInfo.imageLinks.thumbnail : null,
                edition: item.volumeInfo.edition || ''
            }));
            setSearchResults(books);
        } else {
            setSearchResults([]);
        }
    } catch (error) {
        console.error('Error fetching books:', error);
        setSearchResults([]);
    } finally {
        setSearching(false);
    }
};